import {Component} from '@angular/core';
import {MessageService} from 'primeng/api';
import {SequencesService} from '../../../services/sequences.service';
import {translate} from '@ngneat/transloco';
import {SequenceSubscriptionsResponse} from '../../../model/responses/sequence-subscriptions-response';

@Component({
  selector: 'app-sequence-subscription-input',
  templateUrl: './sequence-subscription-input.component.html',
  styleUrls: ['./sequence-subscription-input.component.scss']
})
export class SequenceSubscriptionInputComponent {
  public dialogVisible: boolean;

  private originalEmailsSet: Set<string>;

  public listEmails: string[];
  private emailPattern: RegExp;

  private sequenceUuid: string;

  public loading: boolean = true;
  public modified: boolean = false;

  constructor(private sequencesService: SequencesService,
              private messageService: MessageService) {
    this.emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
    ;
    this.listEmails = [];
  }

  updateSubscription(): void {
    let summaryTr: string;
    let detailTr: string;

    const {newEmails, removeEmails} = this.buildPersistData();

    this.sequencesService.updateSequenceSubscriptions(this.sequenceUuid, newEmails, removeEmails).toPromise()
      .then((): void => {
        summaryTr = translate('success.generic.changesApplied');
        detailTr = translate('success.subscription.update');
        this.messageService.add({severity: 'success', summary: summaryTr, detail: detailTr, sticky: false});
        this.openSubscription(this.sequenceUuid);
      })
      .catch((): void => {
        summaryTr = translate('error.summary.unexpected');
        detailTr = translate('error.subscription.update');
        this.messageService.add({severity: 'error', summary: summaryTr, detail: detailTr, sticky: false});
      });
  }

  buildPersistData() {
    const listEmailsSet: Set<string> = new Set(this.listEmails);
    const newEmails: string[] = [];
    const removeEmails: string[] = [];

    this.listEmails.forEach((email: string): void => {
      if (!this.originalEmailsSet.has(email)) {
        newEmails.push(email);
      }
    });

    this.originalEmailsSet.forEach((email: string): void => {
      if (!listEmailsSet.has(email)) {
        removeEmails.push(email);
      }
    });
    return {newEmails, removeEmails};
  }


  clearList(): void {
    if(this.listEmails.length > 0){
      this.modified = true;
    }
    this.listEmails = [];
  }

  validateEmail(event: any): void {
    if (!this.emailPattern.test(event.value)) {
      this.listEmails.pop();
    } else{
      this.modified = true;
    }
  }

  openSubscription(sequenceUuid: string): void {
    this.loading = true;
    this.dialogVisible = true;
    this.modified = false;
    this.sequenceUuid = sequenceUuid;

    this.listEmails = [];

    this.sequencesService.getSequenceSubscriptions(sequenceUuid).toPromise()
      .then((response: SequenceSubscriptionsResponse): void => {
        this.listEmails = response.sequenceSubscription.emails;
        this.originalEmailsSet = new Set(this.listEmails);
      })
      .finally((): void => {
        this.loading = false;
      });
  }
}
